import { toQueryParams } from "helpers/url";
import appAxios from "./axios";

export class SuperAdminService<T> {
  constructor(public basePath: string) { }

  getAll = (queryParams: object = {}): Promise<any> => {
    return appAxios.get(`/superadmin/${this.basePath}?` + toQueryParams(queryParams));
  };
  get = (id: any, queryParams: any = {}): Promise<T> => appAxios.get(`/superadmin/${this.basePath}/${id}?` + toQueryParams(queryParams));
  delete = (id: number): Promise<number> => appAxios.delete(`/superadmin/${this.basePath}/${id}`);
  post = (data: number): Promise<T> => appAxios.post(`/superadmin/${this.basePath}`, data);
  put = (id: number, data: T): Promise<T> => appAxios.put(`/superadmin/${this.basePath}/${id}`, data);
  patch = (id: any, data: T): Promise<T> => appAxios.patch(`/superadmin/${this.basePath}/${id}`, data);
}
